import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SessionService } from '../services/session.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private sessionService: SessionService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let isAuthenticated: boolean;
    if (!this.sessionService.hasFetrapiSession()) {
      isAuthenticated = false;
      this.router.navigateByUrl(`/login`);
    }
    else {
      isAuthenticated = true;
    }
    return isAuthenticated;
  }
}
